<template>
  <div class="text-gray-500 text-center mx-auto w-3/4 max-w-[350px]">
    <div class="flex justify-center my-4">
      <PermissionStatusCircle icon="icon-camera" ready></PermissionStatusCircle>
    </div>
    <div class="font-bold text-lg text-gray-700">Camera</div>
    <p class="my-6">
      <span class="text-gray-700 font-medium">NCSS</span> requires access to your device's camera to
      <span class="text-gray-700 font-medium">save photos</span> of metering equipment as well as provide a
      <span class="text-gray-700 font-medium">barcode scanner</span> for easy equipment lookup.
    </p>
    <div v-if="cameraPermission.ready">
      <div class="text-lg font-bold text-gray-700">Good to go!</div>
      <p>NCSS has the necessary access to the Camera<br /><span class="text-gray-700 font-bold">Thank you</span></p>
    </div>
    <PermissionDialog v-else>"NCSS" Would Like to Access the Camera</PermissionDialog>
  </div>
</template>

<script setup lang="ts">
import PermissionStatusCircle from '@/components/permissions/PermissionStatusCircle.vue';
import PermissionDialog from './PermissionDialog.vue';
import { useCameraPermission } from '@/stores/permissions/camera-permission.store';

const cameraPermission = useCameraPermission();
</script>

<style scoped></style>
